import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { NEAR_ME } from '../../constants';
import { AutocompletePrediction } from './typesGoogle';

type UseDefaultPlaces = {
  nearMePlace: AutocompletePrediction;
  defaultPlaces: AutocompletePrediction[];
};

const useDefaultPlaces = (): UseDefaultPlaces => {
  const [t] = useTranslation('common');
  const nearMeDescription = t('search--description--near-me');

  return useMemo(() => {
    const nearMePlace = {
      description: nearMeDescription,
      place_id: NEAR_ME,
    };

    const defaultPlaces = [nearMePlace];
    return {
      nearMePlace,
      defaultPlaces,
    };
  }, [nearMeDescription]);
};

export default useDefaultPlaces;
